export const SLICE_NAME = 'externalLinks';
